import { useContext } from "react";
import { setSnackbar } from "../../../util/state/globalAction";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../util/state/globalVariables";

interface SnackbarOptions {
  show?: boolean;
  autoClose?: boolean;
}

const initialOptions: SnackbarOptions = {
  show: true,
  autoClose: true,
};

const useSnackbar = (options: SnackbarOptions = initialOptions) => {
  const { dispatchGlobalData } = useContext(GlobalContext);

  const show = (type: keyof typeof snackbarTypes, message: string) =>
    dispatchGlobalData({
      type: setSnackbar,
      payload: {
        snackbar: {
          message: message,
          type: snackbarTypes[type],
          show: options.show,
          autoClose: options.autoClose,
        },
      },
    });

  return {
    show,
  };
};

export default useSnackbar;
